import { call, options, params } from './helpers';

export const getTeam = (payload) =>
	call(`/beta/company/team${params(payload)}`);

export const getTokens = (payload) =>
	call(`/beta/company/tokens${params(payload)}`);

export const createToken = (payload) =>
	call(`/beta/company/tokens`, options(payload, 'POST'));

export const deleteToken = (payload) =>
	call(`/beta/company/tokens`, options(payload, 'DELETE'));

export const resendToken = (payload) =>
	call(`/beta/tokens/resend`, options(payload, 'PUT'));

export const getRoles = (payload) =>
	call(`/beta/company/roles${params(payload)}`);

export const getPublicCompany = ({ id }) => call(`/beta/company/${id}/public`);

export const getIntegrations = (payload) =>
	call(`/beta/company/integrations${params(payload)}`);

export const getActiveIntegrations = (payload) =>
	call(`/beta/company/integrations/active${params(payload)}`);

export const getIntegration = ({ id }) =>
	call(`/beta/company/integrations/${id}`);

export const getIntegrationSources = ({ id }) =>
	call(`/beta/company/integrations/${id}/sources`);

export const getIntegrationMetrics = ({ id }) =>
	call(`/beta/company/integrations/${id}/metrics`);

export const getIntegrationByWidgetKey = ({ id }) =>
	call(`/beta/company/integrations/widget/${id}`);

export const updateIntegration = ({ id, ...payload }) =>
	call(`/beta/company/integrations/${id}`, options(payload, 'PUT'));

export const removeIntegration = ({ id }) =>
	call(`/beta/company/integrations/${id}`, options(null, 'DELETE'));

export const getWidgetsByType = (payload) =>
	call(`/beta/company/widgets${params(payload)}`);

// API Tokens (v2)
export const getApiTokens = () => call(`/v2/api-tokens`);

export const getApiToken = ({ tokenId }) => call(`/v2/api-tokens/${tokenId}`);

export const createApiToken = (payload) =>
	call(`/v2/api-tokens`, options(payload, 'POST'));

export const updateApiToken = ({ tokenId, ...payload }) =>
	call(`/v2/api-tokens/${tokenId}`, options(payload, 'PATCH'));

export const revokeApiToken = ({ tokenId }) =>
	call(`/v2/api-tokens/${tokenId}`, options(null, 'DELETE'));

export const getApiTokenScopes = () => call(`/v2/api-tokens/scopes`);
